import {ReactNode} from "react";
import {useTheme} from "styled-components";
import {Typography, Column, Image} from "../";

export interface ErrorUIStateProps {
  icon?: ReactNode;
  body?: ReactNode;
  message?: string;
  defaultMessageColor?: string;
}

export const ErrorUIState: React.FC<ErrorUIStateProps> = ({
  icon,
  body,
  message,
  defaultMessageColor,
}) => {
  const {blackWhite} = useTheme();
  return (
    <Column
      gap={15}
      padding="1rem 0"
      textAlign="center"
      alignItems="center"
      justifyContent="center"
    >
      {icon ?? (
        <Image width={50} height={50} src="/images/placeholder/error.png" />
      )}
      {message ? (
        <Typography
          fontSize={15}
          textAlign="center"
          fontFamily="Rubik-Medium"
          color={defaultMessageColor ?? blackWhite}
        >
          {message}
        </Typography>
      ) : (
        <Column
          gap={0}
          textAlign="center"
          alignItems="center"
          justifyContent="center"
        >
          <Typography
            fontSize={17}
            textAlign="center"
            fontFamily="Rubik-Medium"
            color={defaultMessageColor ?? blackWhite}
          >
            ¡Ha sucedido un error!
          </Typography>
          <Typography
            textAlign="center"
            color={defaultMessageColor ?? blackWhite}
          >
            vuelve a intentarlo en un momento
          </Typography>
        </Column>
      )}
      {body && body}
    </Column>
  );
};
